module.exports = __webpack_public_path__ + "static/media/logoorange.48258ac3.png";